import { createContext, useContext } from 'react';

type ModalContext = {
  preventModalClose(args: boolean): void | string | null;
  closePreventedMessage: string | null;
  closeModal(): void;
};
const ModalContext = createContext<ModalContext>({
  preventModalClose: () => null,
  closePreventedMessage: null,
  closeModal: () => null,
});

ModalContext.displayName = 'ModalContext';

export const useModalContext = () => useContext(ModalContext);

export default ModalContext;
